import "./programs.scss";
import { Link } from "react-router-dom";
import littleTigersImg from "../../assets/images/program-little-tigers.jpg";
import bigTigerImg from "../../assets/images/program-big-tiger.jpg";
import familyImg from "../../assets/images/program-family.jpg";
import adultImg from "../../assets/images/program-adult.jpg";
import sparringImg from "../../assets/images/program-sparring.jpg";
import seniorImg from "../../assets/images/program-senior.jpg";

// Programs section (owner request 2026-11-04): the full class lineup —
// Little Tigers (2.5-5), Big Tiger (5-12), Family, Adult (13+, teens
// train together), Sparring, and Senior (50s/60s/70s). Copy stays with
// what the owner specified — no invented schedules, prices, or results.
const PROGRAMS = [
  {
    img: littleTigersImg,
    alt: "Little Tigers class — toddlers training with an instructor",
    title: "Little Tigers",
    ages: "Ages 2½ – 5",
    text: "A first class made just for little ones. In a fun, structured class, our youngest students learn to listen, follow directions and control their bodies — the discipline they build here carries into school and home.",
    points: [
      "Discipline & self-control",
      "Listening & focus",
      "Respect & confidence",
      "Balance & coordination",
    ],
  },
  {
    img: bigTigerImg,
    alt: "Big Tiger class — kids ages 5 to 12 practicing taekwondo",
    title: "Big Tiger",
    ages: "Ages 5 – 12",
    text: "Where young students build real martial arts skills. A full curriculum that grows with your child — from their first stance to confident, controlled technique.",
    points: [
      "Basics · Blocking",
      "Kicking & punching",
      "Weapons training",
      "Self-defense",
      "Discipline · control · focus",
      "Personal development",
    ],
  },
  {
    img: familyImg,
    alt: "Family class — parents and children training together",
    title: "Family Class",
    ages: "All Siblings Together",
    text: "Brothers, sisters, moms and dads — the whole family trains together. One family, one dojang. Come try it out together.",
    points: [
      "Brothers & sisters",
      "Moms & kids",
      "Dads & kids",
      "Try out together",
    ],
  },
  {
    img: adultImg,
    alt: "Adult class — teens and adults training together",
    title: "Adult Taekwondo",
    ages: "Ages 13+ · Teens Train Together",
    text: "Not a kids' class with adults in it — a program built for ages 13 and up, where teens train right alongside adults. Get in shape, relieve stress and learn practical self-defense, training at your own pace with expert instruction. No experience needed.",
    points: [
      "Full-body fitness",
      "Stress relief",
      "Practical self-defense",
      "Train at your own pace",
    ],
  },
  {
    img: sparringImg,
    alt: "Sparring class — real sparring with protective gear",
    title: "Sparring Class",
    ages: "Real-Combat Sparring",
    text: "Real sparring — boxing, kickboxing, MMA and taekwondo combined in one real-combat sparring program. Learn true self-defense.",
    points: [
      "Boxing · Kickboxing",
      "MMA · Taekwondo",
      "Real-combat sparring",
      "True self-defense",
    ],
  },
  {
    img: seniorImg,
    alt: "Senior class — adults in their 50s to 70s training",
    title: "Senior Class",
    ages: "50s · 60s · 70s — Not Too Late",
    text: "In your 50s, 60s or 70s? It's not too late. Personalized training built around you — strength, stretching, balance, breathing, martial arts technique and self-defense are all possible. Today is the earliest day — seize the opportunity. You won't regret it.",
    points: [
      "Personalized training",
      "Strength · stretching · balance",
      "Breathing & technique",
      "Self-defense",
    ],
  },
];

export default function Programs() {
  return (
    <section className="section programs-section" id="programs">
      <div className="container programs-container">
        <p className="programs-eyebrow">OUR PROGRAMS</p>
        <h2 className="programs-title">A Class for Every Age</h2>
        <p className="programs-lead">
          From toddlers taking their very first class to seniors starting
          in their 60s — every student starts with 1 FREE class.
        </p>

        <div className="grid programs-grid">
          {PROGRAMS.map((p) => (
            <div className="program-card" key={p.title}>
              <img className="program-photo" src={p.img} alt={p.alt} />
              <div className="program-body">
                <h3>{p.title}</h3>
                <p className="program-ages">{p.ages}</p>
                <p className="program-text">{p.text}</p>
                <ul className="program-points">
                  {p.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
                <Link to="/#trial" className="program-cta">
                  Book a FREE Class
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
